import styled from '@emotion/styled/macro';
import { Variables } from '../base/variables';

const V = Variables.ThemeLight;

/**
 * A chip that is also a button. Relative import of `Variables`, not `@enter/core` — inside core
 * that is a self-import, which resolves to undefined at module init and renders a blank page
 * while compiling perfectly cleanly.
 */
export const Chip = styled.button<{ copied: boolean }>`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 2px 8px;
    border-radius: 5px;
    cursor: pointer;
    white-space: nowrap;
    color: ${({ copied }) => (copied ? V.SuccessConstant6 : V.TextMedium)};
    background: ${V.Background1};
    border: 1px solid ${({ copied }) => (copied ? V.SuccessConstant6 : V.Border1)};
    transition: color 120ms ease-out, border-color 120ms ease-out;

    :hover {
        border-color: ${V.PrimaryConstant6};
        color: ${V.PrimaryInverted3};
    }
`;

export const Label = styled.span`
    font: 600 9px/1.6 var(--font-sans, inherit);
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: ${V.TextMild};
`;

/** Monospace, so it reads as a key rather than a number to type into a clearinghouse form. */
export const Value = styled.span`
    font: 500 11px/1.5 var(--font-mono, monospace);
`;
